import React from "react";

export default class PrivacyPolicy extends React.Component {
    render() {
        return (
            <div className="min-h-screen bg-[#f8fafc] text-[#0f172a] px-6 py-10 md:px-20">
                <div className="max-w-4xl mx-auto">
                    <div className="hk-eyebrow">Legal</div>
                    <h1 className="hk-display text-4xl font-bold mb-3">Privacy Policy</h1>
                    <p className="text-sm text-gray-500 mb-10">
                        Last updated: May 30, 2026
                    </p>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
                        <p>
                            This Privacy Policy describes how Haki collects, uses, and protects
                            your information when you use our services, websites, and
                            applications. By using Haki, you agree to the terms outlined in
                            this policy.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">2. Information We Collect</h2>
                        <p>
                            We may collect personal information such as name, email address,
                            phone number, and usage data. We also collect technical data such
                            as IP address, browser type, and device information to improve our
                            services.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">3. How We Use Information</h2>
                        <p>
                            We use collected data to operate, maintain, and improve our
                            services, provide customer support, send important updates, and
                            enhance user experience. We do not sell your personal data.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">4. Data Sharing</h2>
                        <p>
                            We may share data with trusted third-party service providers who
                            assist us in operating our services. These providers are obligated
                            to keep your information secure and confidential.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">5. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures to
                            protect your data from unauthorized access, alteration, or
                            destruction.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">6. Your Rights</h2>
                        <p>
                            Depending on your location, you may have rights to access,
                            correct, or delete your personal data. You may also opt out of
                            certain communications at any time.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">7. Cookies</h2>
                        <p>
                            We use cookies and similar tracking technologies to enhance
                            functionality and analyze usage patterns. You can manage cookie
                            preferences in your browser settings.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">8. Changes to This Policy</h2>
                        <p>
                            We may update this Privacy Policy from time to time. Changes will
                            be posted on this page with an updated revision date.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-xl font-semibold mb-2">9. Contact Us</h2>
                        <p>
                            If you have any questions about this Privacy Policy, you can
                            contact us at support@haki.com.
                        </p>
                    </section>

                    <footer className="mt-12 text-sm text-gray-500">
                        © {new Date().getFullYear()} Haki. All rights reserved.
                    </footer>
                </div>
            </div>
        );
    }
}
